/* eslint-disable import/extensions */

import {type Inventory} from '@unbrs/plastic-data';
import {type InventoryData} from '@unbrs/plastic-data/src/types/inventory';
import {BrsBaseWidget} from '../base';
import html from './views/inventory-view.tmpl.html';
import {BrsInventory} from './inventory';

BrsBaseWidget.registerBrsWidget(BrsInventory);

type BrsInventoriesOptions = {
	dataSource?: kendo.data.DataSource;
	pageable?: boolean;
};

export class BrsInventories extends kendo.ui.Widget {
	private readonly woptions: BrsInventoriesOptions;
	private dataSource?: kendo.data.DataSource;
	private readonly listDataSource?: kendo.data.DataSource;

	constructor(selector: Element, options: BrsInventoriesOptions) {
		super(selector, options);
		const defaultOptions: BrsInventoriesOptions = {
			pageable: true,
		};
		this.woptions = {...defaultOptions, ...options};
		this.element.html(html);

		this.listDataSource = new kendo.data.DataSource({
			serverPaging: false,
		});
		this.listDataSource.bind('change', this.refreshPanelBar.bind(this));

		if (this.woptions.dataSource) {
			this.setDataSource(this.woptions.dataSource);
		}

		this.onInit();
	}

	initListWidget() {
		const listelem = $('.brs-inventories-list', this.element);
		listelem.kendoListView({
			autoBind: false,
			dataSource: this.listDataSource,
			template: () => '<div class="k-listview-item collapsible"></div>',
			pageable: this.woptions.pageable,
			dataBound: event => {
				event.sender.content.data('kendoPanelBar')?.destroy();
				$('.k-listview-item', event.sender.element).each((i, element) => {
					$(element).kendoBrsInventory({
						inventory: event.sender.dataSource.view()[i] as Inventory.InventoryData,
					});
				});
				this.refreshPanelBar();
			},
		});
	}

	onInit() {
		this.initListWidget();
	}

	setDataSource(dataSource: kendo.data.DataSource | InventoryData[]) {
		if (Array.isArray(dataSource)) {
			this.dataSource = new kendo.data.DataSource({
				data: dataSource,
			});
			this.refresh({items: dataSource});
		} else {
			this.dataSource = dataSource;
			this.dataSource.bind('change', this.refresh.bind(this));
		}
	}

	refreshPanelBar() {
		const listView = $('.brs-inventories-list', this.element).data('kendoListView');
		if (!listView?.content) {
			return;
		}

		// ListView.content.data('kendoPanelBar')?.destroy();
		// listView.element.find('.k-pager-info').show();

		listView.content.kendoPanelBar(
			{
				collapse(event: kendo.ui.PanelBarExpandEvent) {
					if (event.item) {
						$(event.item).find('>span').removeClass('k-selected');
					}
				},
			},
		);
	}

	refresh(event: {items: Inventory.InventoryData[]}) {
		if (event.items && this.listDataSource) {
			// Don't show umbrella projects
			this.listDataSource.data(event.items);
			if (this.listDataSource.page() && this.listDataSource.page() !== 1) {
				this.listDataSource.page(1);
			}
		}
	}
}

declare global {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface JQuery {
		kendoBrsInventories(options?: BrsInventoriesOptions): JQuery;
		data(widgetName: 'kendoBrsInventories'): BrsInventories;
	}
}
